
import { IPackage } from "@/interfaces/mlm";
import {
  dispatchGetOrCreateInvoice,
  dispatchGetPackages,
  dispatchGetPaymentStatus,
  dispatchProcessConfirmInvoice, dispAuthFetch,
} from "@/store/mlm/actions";
import { readActivePackage, readInvoiceResponse } from "@/store/mlm/getters";
import { Component, Vue, Prop } from "vue-property-decorator";
import { readUserProfile } from "@/store/main/getters";
import UiSmallLoader from "./Ui/UiSmallLoader.vue";
import ChangeEmailModal from "@/components/Main/ChangeEmailModal.vue";
import ByTariffFromDexNetTokenModal from "@/components/Main/ByTariffFromDexNetTokenModal.vue";

@Component({
  components: {UiSmallLoader, ByTariffFromDexNetTokenModal, ChangeEmailModal},
})
export default class PackagePaymentNewModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;
  // @ts-ignore
  @Prop({ required: true, default: null }) public readonly pack: IPackage;

  public loadingState: any = {
    standart: false,
    submit: false,
  };
  public standart: string = "";
  public transaction: any = null;
  public isModalClosed: boolean = false;
  public isShowModalByTariffFromDexNetToken: boolean = false
  public selectedYear = false
  public hasAccountDexNet: boolean|string = false
  public isChecked6 = false
  public purchaseRequest = null
  public email1 = ""
  public email2 = ""
  public invoiceId = null
  public errorMessage = ""

  public needSomeMoney () {
    const balance = this.userProfile
        ? Number(this.userProfile.balances.units_total)
        : 0;
    const r = Math.abs(balance - this.pack.price)
    return Math.round(r);
  }

  public selectYear(year) {
    this.selectedYear = this.selectedYear === year ? null : year;
  }

  public selectAccountDexNet(type) {
    this.hasAccountDexNet = this.hasAccountDexNet === type ? null : type;
  }

  public async mounted() {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/token_service_integration/token_package/purchase/request/",
      init: {
        method: "POST",
        body: {
          token_package: this.pack.id,
          standart: "BEP20",
          token: "USDT"
        },
      },
    });

    if (invoiceResp && invoiceResp.status === 200) {
      this.invoiceId = (await invoiceResp.json()).invoice.id
    } else if (invoiceResp && invoiceResp.status === 400) {
      this.$toast.error("Error");
    }
  }


  public async buy() {
    this.errorMessage = ""
    if(this.email1 != this.email2){
      this.errorMessage = this.$t("Invalid email").toString()
      return;
    }
    this.loadingState.submit = true

    let email = ""
    if (this.hasAccountDexNet == 'no'){
      email = this.userProfile?.email ?? ""
    } else {
      email = this.email1
    }

    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/token_service_integration/token_package/purchase/confirm/",
      init: {
        method: "POST",
        body: {
          invoice: this.invoiceId,
          period: this.selectedYear,
          email: email
        },
      },
    });

    if (invoiceResp && invoiceResp.status === 200) {
      this.purchaseRequest = await invoiceResp.json()
      this.$toast.success(this.$t('successfully').toString())
      this.closeModal()
    } else if (invoiceResp && invoiceResp.status === 400) {
      const error = await invoiceResp.json()
      if(error.email)
        this.errorMessage = this.$t("Invalid email").toString()
      if(error.detail)
        this.errorMessage = this.$t('This package is temporarily unavailable').toString()
      if(error.invoice)
        this.errorMessage = this.$t('Insufficient funds').toString()
      this.$toast.error(this.$t("ERROR").toString() + ": " + this.errorMessage);
    }

    this.loadingState.submit = false
  }

  public closeModal() {
    this.isModalClosed = true;
    this.$emit("close-modal");
  }

  get invoiceResponse() {
    return readInvoiceResponse(this.$store);
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
